<template>
  <div class="resizable-component bili-note">
    <slot name="note-drag-bar"> </slot>
    <vue-editor
      class="h-100 my-editor"
      style="height: 100%; width: 100%"
      :editorOptions="editorSettings"
      :editor-toolbar="customToolbar"
      :useCustomImageHandler="true"
      v-model="editorContent"
      @image-added="handleImageAdded"
      @image-removed="handleImageRemoved"
      @input="handleInputEditorContent"
      :disabled="!c_isEditable"
      ref="vEditor"
    ></vue-editor>
  </div>
</template>
<script>
import { VueEditor } from 'vue2-editor';

import { MtEditorMixin } from '@/mixins/MtEditor';

export default {
  name: 'MtEditor',

  mixins: [MtEditorMixin],

  components: {
    VueEditor,
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
